<template>
  <div class="clickable" @click.stop.prevent="preguntar">
    <slot></slot>
  </div>
</template>

<script>
/**
 * La idea de este componete es que sea un envoltorio de un botón o un
 * link o algo y al hacer click pida confirmación. El uso habitual será
 * el de un botón de borrar
 */
import dialogs from '../../libs/cifra/dialogs';

export default {
  props: {
    tipo: { type: String, default: 'eliminar' },
    options: { type: Object, default: undefined },
  },
  methods: {
    preguntar() {
      if (this.tipo === 'eliminar') {
        dialogs.confirmarEliminar(this.options).then((confirmacion) => {
          if (confirmacion === true) {
            this.$emit('confirmado');
          }
        });
      }
    },
  },
};
</script>
